<template>
  <div id="app">
    <keep-alive :include="['FormOrgCo', 'FormOrgAdmin', 'FormOrgMe', 'FormMeCo', 'OrderOrg']">
      <router-view :key="key" />
    </keep-alive>
  </div>
</template>

<script>
// import ResizeMixin from '@/utils/mixinResizeHandler'

export default {
  name: 'App',
  // mixins: [ResizeMixin],
  computed: {
    // 异步路由，通过计算属性获取(直接获取不到)
    key() {
      return this.$route.fullPath
    }
    // keepAlive() {
    //   console.log(this.$route.meta)
    //   return this.$route.meta.keepAlive
    // }
  },
  created() {
  },
  mounted() {
  }
}
</script>
